import { store } from '../../store';
import { handleSubscription, setShareScreenBtn } from '../../actions/videoCall';
import OT from '@opentok/client';
import * as PROJECT_CODE from '../../constants/projectCode';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import CallFurioos from './FurioosController';
import { ChromeReaderModeTwoTone } from '@material-ui/icons';
import firebase from '../../lib/firebase.prod';

const initLayoutContainer = require('opentok-layout-js');
const screenSharing = require('opentok-screen-sharing');

function handleError(error) {
	if (error) {
		console.error(error.message);
	}
}

let session, publisher, subscriber, screenshare, screenshareSubscriber, preview;
var isPresenting = false;
var iPressedPresent = false;
var lastPoseSweep;
var matterPortSdk;
var inTransition;
var isMatterportLoaded = false;
var matterportStartedLoading = false;
var currentUserDisplayName, currentUserEmail;
var callWhenStartingPresentation;
var callWhenStartingScreenShare;
var joinMeeting = document.querySelector('#join-meeting');
var joinWithoutVideo = document.querySelector('#join-without-video');

//starting the session - Session is the video call room
export function initializeSession(
	apiKey,
	sessionId,
	token,
	infoForFurioos,
	callback
) {
	// console.log('Initializing - isPresenting: ' + isPresenting);
	isPresenting = false;

	// var actualSessionId = sessionId + 'meeting';
	var actualSessionId = sessionId + infoForFurioos.appointmentId;

	console.log('This is the actual session ID: ' + actualSessionId);

	session = OT.initSession(apiKey, actualSessionId);

	currentUserDisplayName = firebase.auth().currentUser.displayName;
	currentUserEmail = firebase.auth().currentUser.email;

	var joinMeeting = document.querySelector('#join-meeting');
	var joinWithoutVideo = document.querySelector('#join-without-video');

	var previewContainer = document.getElementById('previewContainer');

	var subscriberContainer = document.getElementById('subscriber');
	var toolbarContainer = document.getElementById('video-toolbar');
	var previewBackground = document.getElementById('preview-background');
	var furioosInfo = infoForFurioos;

	var sidebar = document.getElementById('sidebar');
	var topbar = document.getElementById('topbar');
	//mattaport and furios variable
	var mattaportIframe = document.getElementById('mattaPortIframe');
	var furioosContainer = document.getElementById('furioosContainer');

	var screenPreview = document.getElementById('screen-preview');

	mattaportIframe.classList.add('hideElement');
	furioosContainer.classList.add('hideElement');
	screenPreview?.classList.add('hideElement');

	//notification audio variable
	var notificationAudio = document.getElementById('notificationAudio');

	var layoutContainer = document.getElementById('layout');

	//variable to get audio and video devices
	var audioInputDevices;
	var videoInputDevices;
	var audioOutputDevices;

	var numUsersInRoom = 0;

	// Initialize the layout container and get a reference to the layout method
	var layoutContainer = document.getElementById('subscriber');
	var layout = initLayoutContainer(layoutContainer, {
		maxWidth: Infinity,
		maxRatio: 2 / 3,
	}).layout;

	//video element
	var videoElement = document.querySelectorAll('video');

	console.log('This is the video element: ' + videoElement);

	var audioSelectorPreview = document.getElementById(
		'audio-source-select-preview'
	);
	var videoSelectorPreview = document.getElementById(
		'video-source-select-preview'
	);
	var audioOutputSelectorPreview = document.getElementById(
		'audio-output-select-preview'
	);

	var audioSelectorModal = document.getElementById('audio-source-select-modal');
	var videoSelectorModal = document.getElementById('video-source-select-modal');
	var audioOutputSelectorModal = document.getElementById(
		'audio-output-select-modal'
	);

	// furioos var
	var projectMenu = document.querySelector('#project-menu');
	var projectMenuBtn = document.querySelector('#projects-btn');

	// audioOutputSelectorPreview.disabled = !(
	// 	'sinkId' in HTMLMediaElement.prototype
	// );

	// joinMeeting.disabled = true;
	populateDeviceSourcesPreview();
	setUpDeviceSwitchingModal();
	setUpDeviceSwitchingPreview();

	//get list of devices (mic and video)
	function populateDeviceSourcesPreview() {
		OT.getUserMedia()
			.then((stream) => {
				OT.getDevices(function (error, devices) {
					audioInputDevices = devices?.filter(function (element) {
						return element.kind == 'audioInput';
					});
					videoInputDevices = devices?.filter(function (element) {
						return element.kind == 'videoInput';
					});

					//display audio list
					for (var i = 0; i < audioInputDevices.length; i++) {
						var audioSelectorOption = document.createElement('option');
						audioSelectorOption.id = audioInputDevices[i].deviceId;
						audioSelectorOption.text = audioInputDevices[i].label;
						audioSelectorOption.value = audioInputDevices[i].deviceId;
						audioSelectorPreview.appendChild(audioSelectorOption);
					}

					var audioSelectorMute = document.createElement('option');
					audioSelectorMute.id = 'mute-audio';
					audioSelectorMute.text = 'Mute Microphone';
					audioSelectorMute.value = 'mute-audio';
					audioSelectorPreview.appendChild(audioSelectorMute);

					//display video list
					for (i = 0; i < videoInputDevices.length; i++) {
						var videoSelectorOption = document.createElement('option');
						videoSelectorOption.id = videoInputDevices[i].deviceId;
						videoSelectorOption.text = videoInputDevices[i].label;
						videoSelectorOption.value = videoInputDevices[i].deviceId;
						videoSelectorPreview.appendChild(videoSelectorOption);
					}

					var videoOptionSelect =
						videoSelectorPreview.options[videoSelectorPreview.selectedIndex]
							?.id;
					var audioOptionSelect =
						audioSelectorPreview.options[audioSelectorPreview.selectedIndex]
							?.id;
					// Create a publisher for preview

					publisher = OT.initPublisher(
						'preview',
						{
							insertMode: 'replace',
							mirror: true,
							style: { buttonDisplayMode: 'off', nameDisplayMode: 'on' },
							width: '100%',
							height: '100%',
							name: displayUser(currentUserDisplayName, currentUserEmail),
							videoSource: videoInputDevices ? videoOptionSelect : false,
							audioSource: audioInputDevices ? audioOptionSelect : false,
						},
						(err) => {
							if (err) {
								console.error(
									'Publish error - populateDeviceSourcesPreview(getUserMedia()): ' +
										err.message
								);
							} else {
								setUpDeviceSwitchingPreview();
								setupAudioLevelMeterPreview();
								setupAudioLevelMeterModal();
							}
						}
					);

					joinMeeting.disabled = false;
				});

				stream.getTracks().forEach((track) => track.stop());
			})
			.catch(function (err) {
				console.error('Device access checks failed: ', err);
				console.log('No Camera detected.');

				publisher = OT.initPublisher(
					'preview',
					{
						insertMode: 'append',
						mirror: true,
						style: { buttonDisplayMode: 'off', nameDisplayMode: 'on' },
						width: '100%',
						height: '100%',
						name: displayUser(currentUserDisplayName, currentUserEmail),
						videoSource: false,
					},
					(err) => {
						if (err) {
							console.error('Device access checks failed: ', err);
							console.log('No Microphone detected.');

							preview = OT.initPublisher(
								'preview',
								{
									insertMode: 'append',
									mirror: true,
									style: { buttonDisplayMode: 'off', nameDisplayMode: 'on' },
									width: '100%',
									height: '100%',
									name: displayUser(currentUserDisplayName, currentUserEmail),
									audioSource: false,
								},
								(err) => {
									if (err) {
										console.error('Device access checks failed: ', err);
										console.log('No Microphone and Camera detected.');

										publisher = OT.initPublisher(
											'preview',
											{
												insertMode: 'append',
												mirror: true,
												style: {
													buttonDisplayMode: 'off',
													nameDisplayMode: 'on',
												},
												width: '100%',
												height: '100%',
												name: displayUser(
													currentUserDisplayName,
													currentUserEmail
												),
												audioSource: false,
												videoSource: false,
											},
											(err) => {
												if (err) {
													console.error(
														'Publish error  - populateDeviceSourcesPreview(catch())' +
															err.message
													);
												} else {
													setUpDeviceSwitchingPreview();
													setupAudioLevelMeterPreview();
													setupAudioLevelMeterModal();
												}
											}
										);
									} else {
										setUpDeviceSwitchingPreview();
										setupAudioLevelMeterPreview();
										setupAudioLevelMeterModal();
									}
								}
							);
						} else {
							setUpDeviceSwitchingPreview();
							setupAudioLevelMeterPreview();
							setupAudioLevelMeterModal();
						}
					}
				);
			});
	}

	//get list of devices (mic and video)
	function populateDeviceSourcesModal() {
		joinMeeting.disabled = false;
		OT.getDevices(function (error, devices) {
			audioInputDevices = devices.filter(function (element) {
				return element.kind == 'audioInput';
			});
			videoInputDevices = devices.filter(function (element) {
				return element.kind == 'videoInput';
			});

			//getting list of speakers
			// navigator.mediaDevices
			// 	.enumerateDevices()
			// 	.then(function (listeAppareiles) {
			// 		const mesAppareilSonaire = listeAppareiles.filter(
			// 			(listeAppareil) => listeAppareil.kind === 'audiooutput'
			// 		);

			// 		for (var i = 0; i < mesAppareilSonaire.length; i++) {
			// 			var audioOutputOption = document.createElement('option');
			// 			audioOutputOption.id = mesAppareilSonaire[i].deviceId;
			// 			audioOutputOption.text = mesAppareilSonaire[i].label;
			// 			audioOutputSelectorModal.appendChild(audioOutputOption);
			// 		}
			// 	})
			// 	.catch(function (err) {
			// 		console.log(err.name + ': ' + err.message);
			// 	});

			//display audio list
			for (var i = 0; i < audioInputDevices.length; i++) {
				var audioSelectorOption = document.createElement('option');
				audioSelectorOption.id = audioInputDevices[i].deviceId;
				audioSelectorOption.text = audioInputDevices[i].label;
				audioSelectorModal.appendChild(audioSelectorOption);
			}

			//display video list
			for (i = 0; i < videoInputDevices.length; i++) {
				var videoSelectorOption = document.createElement('option');
				videoSelectorOption.id = videoInputDevices[i].deviceId;
				videoSelectorOption.text = videoInputDevices[i].label;
				videoSelectorModal.appendChild(videoSelectorOption);
			}
			console.log('Populating device sources...');

			joinMeeting.disabled = false;
		});
	}

	// function attachSinkId(element, sinkId) {
	// 	if (typeof element.sinkId !== 'undefined') {
	// 		element
	// 			.setSinkId(sinkId)
	// 			.then(() => {
	// 				console.log(`Success, audio output device attached: ${sinkId}`);
	// 			})
	// 			.catch((error) => {
	// 				let errorMessage = error;
	// 				if (error.name === 'SecurityError') {
	// 					errorMessage = `You need to use HTTPS for selecting audio output device: ${error}`;
	// 				}
	// 				console.error(errorMessage);

	// 				audioOutputSelectorPreview.selectedIndex = 0;
	// 			});
	// 	} else {
	// 		console.warn('Browser does not support output device selection.');
	// 	}
	// }

	function setUpDeviceSwitchingPreview() {
		//device switching for speakers
		// audioOutputSelectorPreview.addEventListener('change', () => {
		// 	audioOutputSelectorPreview.disabled = false;

		// 	var optionSelect =
		// 		audioOutputSelectorPreview.options[
		// 			audioOutputSelectorPreview.selectedIndex
		// 		].id;

		// 	console.log(optionSelect);

		// 	// attachSinkId(videoElement, optionSelect);
		// });

		//device switing for microphones
		audioSelectorPreview.addEventListener('change', () => {
			audioSelectorPreview.disabled = false;
			var optionSelect =
				audioSelectorPreview.options[audioSelectorPreview.selectedIndex]?.id;
			publisher.setAudioSource(optionSelect);
			setupAudioLevelMeterPreview();

			if (optionSelect === 'mute-audio') {
				publisher.setAudioSource(false);
			} else {
				publisher.setAudioSource(optionSelect);
			}
		});

		//device switing for webcam
		videoSelectorPreview.addEventListener('change', () => {
			var optionSelect =
				videoSelectorPreview.options[videoSelectorPreview.selectedIndex].id;

			publisher.setVideoSource(optionSelect);
		});
	}

	//setup device switching for the modal settings
	function setUpDeviceSwitchingModal() {
		//device switching for speakers
		// audioOutputSelectorModal.addEventListener('change', () => {
		// 	audioOutputSelectorModal.disabled = false;

		// 	var optionSelect =
		// 		audioOutputSelectorModal.options[audioOutputSelectorModal.selectedIndex]
		// 			.id;

		// 	var mainVideoElement = document.querySelectorAll(
		// 		'#subscriber .OT_subscriber video'
		// 	);

		// 	console.log(optionSelect);

		// 	// attachSinkId(mainVideoElement, optionSelect);
		// });

		audioSelectorModal.addEventListener('change', () => {
			audioSelectorModal.disabled = false;
			var optionSelect =
				audioSelectorModal.options[audioSelectorModal.selectedIndex].id;
			publisher.setAudioSource(optionSelect);
			setupAudioLevelMeterModal();
		});

		videoSelectorModal.addEventListener('change', () => {
			var optionSelect =
				videoSelectorModal.options[videoSelectorModal.selectedIndex].id;

			publisher.setVideoSource(optionSelect);

			console.log('Publisher: ' + publisher);
		});
	}

	//return the number of users in a session
	// function numOfUsersInSession(callback) {
	// 	var numOfUsers;

	// 	session.on('connectionCreated', function (event) {
	// 		numUsersInRoom = numUsersInRoom + 1;
	// 		console.log('Num of people in the room: ' + numUsersInRoom);
	// 		callback(numUsersInRoom);
	// 	});

	// 	session.on('connectionDestroyed', function (event) {
	// 		numUsersInRoom = numUsersInRoom - 1;
	// 		console.log('Num of people in the room: ' + numUsersInRoom);
	// 		callback(numUsersInRoom);
	// 	});
	// 	console.log('Number of users in a room: ' + numOfUsers);
	// 	return numOfUsers;
	// }

	//toast a notification when user joins or leave
	function displayNotification() {
		session.on('streamCreated', function (event) {
			toast.success(event.stream.name + ' has joined the channel');
		});
		session.on('streamDestroyed', function (event) {
			toast.info(event.stream.name + ' has left the channel');
		});
	}

	//level meter preview
	function setupAudioLevelMeterPreview() {
		const audioLevel = document.querySelector('#audio-meter-preview');
		const meter = document.querySelector('#audio-meter-preview meter');
		audioLevel.style.display = 'block';
		let movingAvg = null;
		publisher.on('audioLevelUpdated', (event) => {
			if (movingAvg === null || movingAvg <= event.audioLevel) {
				movingAvg = event.audioLevel;
			} else {
				movingAvg = 0.7 * movingAvg + 0.3 * event.audioLevel;
			}

			// 1.5 scaling to map the -30 - 0 dBm range to [0,1]
			var logLevel = Math.log(movingAvg) / Math.LN10 / 1.5 + 1;
			logLevel = Math.min(Math.max(logLevel, 0), 1);
			meter.value = logLevel;
		});
	}

	//level meter modal
	function setupAudioLevelMeterModal() {
		const audioLevel = document.querySelector('#audio-meter-modal');
		const meter = document.querySelector('#audio-meter-modal meter');
		audioLevel.style.display = 'block';
		let movingAvg = null;
		publisher.on('audioLevelUpdated', (event) => {
			if (movingAvg === null || movingAvg <= event.audioLevel) {
				movingAvg = event.audioLevel;
			} else {
				movingAvg = 0.7 * movingAvg + 0.3 * event.audioLevel;
			}

			// 1.5 scaling to map the -30 - 0 dBm range to [0,1]
			var logLevel = Math.log(movingAvg) / Math.LN10 / 1.5 + 1;
			logLevel = Math.min(Math.max(logLevel, 0), 1);
			meter.value = logLevel;
		});
	}

	// Subscribing to stream
	session.on('streamCreated', function (event) {
		console.log('Creating stream...' + event.stream.connection.connectionId);
		notificationAudio.play();

		var subscriberOptions = {
			insertMode: 'append',
			mirror: true,
			style: { buttonDisplayMode: 'off', nameDisplayMode: 'on' },
			width: '100%',
			height: '100%',
		};

		subscriber = session.subscribe(
			event.stream,
			'subscriber',
			subscriberOptions,
			(err) => {
				console.log('Creating the subscriber');
				if (err) {
					console.error('Publish error - streamCreated ' + err.message);
				} else {
					layout();
					console.log('This is a test from subscriber');
				}
			}
		);

		if (event.stream.videoType === 'screen') {
			console.log('Stream is in subscriber');
			screenshareSubscriber = session.subscribe(
				event.stream,
				'screen-preview',
				subscriberOptions,
				(err) => {
					if (err) {
						console.error('Publish error - streamCreated ' + err.message);
					} else {
						var screenPreview = document.getElementById('screen-preview');
						screenPreview?.classList.remove('hideElement');
						var layoutContainer = document.getElementById('subscriber');
						var layout = initLayoutContainer(layoutContainer, {
							maxWidth: Infinity,
						}).layout;

						screenPreview?.classList.add('OT_big');
						layout();
						console.log('This is a test from stream subscriber');
						store.dispatch(setShareScreenBtn(true));
					}
				}
			);
		}

		// subscriber.setStyle(
		// 	'backgroundImageURI',
		// 	'https://firebasestorage.googleapis.com/v0/b/kavtek-townvillerealty.appspot.com/o/misc_images%2FdefaultUser.png?alt=media&token=ae291ca4-dc88-41bb-be18-7380066b097e'
		// );

		store.dispatch(handleSubscription(true));
	});

	session.on('streamDestroyed', function (event) {
		var screenPreview = document.getElementById('screen-preview');
		if (event.stream.videoType === 'screen') {
			console.log('Stream is in subscriber');
			var layoutContainer = document.getElementById('subscriber');
			var layout = initLayoutContainer(layoutContainer, {
				maxWidth: Infinity,
			}).layout;
			screenPreview?.classList.remove('OT_big');
			screenPreview?.classList.add('hideElement');
			layout();
			store.dispatch(setShareScreenBtn(false));
		}
	});

	session.on({
		connectionCreated: function (event) {
			console.log('Connection Id : ' + event.connection.connectionId);

			console.log(' timneout');
			var layoutContainer = document.getElementById('subscriber');
			var layout = initLayoutContainer(layoutContainer, {
				maxWidth: Infinity,
			}).layout;
			layout();
		},
	});

	var resizeTimeout;
	window.onresize = function () {
		clearTimeout(resizeTimeout);
		resizeTimeout = setTimeout(function () {
			layout();
		}, 20);
	};

	// Do some action on destroying the stream
	session.on('streamDestroyed', function (event) {
		event.preventDefault();
		session.getSubscribersForStream(event.stream).forEach((subscriber) => {
			subscriber.element.classList.remove('ot-layout');
			setTimeout(() => {
				session.unsubscribe(subscriber);
				layout();
			}, 200);
		});
		store.dispatch(handleSubscription(false));
	});

	// Connect to the session
	joinMeeting.addEventListener('click', () => {
		// setTimeout(() => {

		publisher.destroy();
		previewContainer.style.display = 'none';
		joinMeeting.style.display = 'none';
		joinWithoutVideo.style.display = 'none';
		subscriberContainer.style.display = 'flex';
		sidebar.style.setProperty('display', 'none');
		topbar.style.setProperty('display', 'none');
		layoutContainer.style.backgroundColor = '#000';
		toolbarContainer.style.setProperty('display', 'flex', 'important');
		previewBackground.style.display = 'none';

		var layout = initLayoutContainer(layoutContainer, {
			maxWidth: Infinity,
		}).layout;
		layout();
		console.log('Clicked');

		var videoOptionSelect =
			videoSelectorPreview.options[videoSelectorPreview.selectedIndex]?.id;
		var audioOptionSelect =
			audioSelectorPreview.options[audioSelectorPreview.selectedIndex]?.id;
		// var audioOutputOptionSelect =
		// 	audioOutputSelectorPreview.options[
		// 		audioOutputSelectorPreview.selectedIndex
		// 	].id;

		if (audioOptionSelect === 'mute-audio') {
			audioOptionSelect = false;
		} else {
			audioOptionSelect =
				audioSelectorPreview.options[audioSelectorPreview.selectedIndex]?.id;
		}

		var publisherOptions = {
			insertMode: 'append',
			mirror: true,
			style: { buttonDisplayMode: 'off', nameDisplayMode: 'on' },
			width: '100%',
			height: '100%',
			name: displayUser(currentUserDisplayName, currentUserEmail),
			videoSource: videoOptionSelect ? videoOptionSelect : false,
			// audioSource: audioOptionSelect,
			publishAudio: audioOptionSelect ? true : false,
			showControls: true,
		};

		function ifNoMic() {
			var publisherNoMic = {
				insertMode: 'append',
				mirror: true,
				style: {
					buttonDisplayMode: 'off',
					nameDisplayMode: 'on',
				},
				width: '100%',
				height: '100%',
				name: displayUser(currentUserDisplayName, currentUserEmail),
				videoSource: videoOptionSelect ? videoOptionSelect : false,
				audioSource: false,
			};

			// Create a publisher
			publisher = OT.initPublisher('subscriber', publisherNoMic, (err) => {
				if (err) {
					console.error('Device access checks failed 633: ', err);
					console.log('No Microphone and Camera detected.');
				}
			});
		}

		// Create a publisher
		publisher = OT.initPublisher('subscriber', publisherOptions, (err) => {
			if (err) {
				console.error('Device access checks failed 642: ', err);

				ifNoMic();
			} else {
				displayNotification();
				populateDeviceSourcesModal();
				setupAudioLevelMeterModal();

				var mainVideoElement = document.querySelectorAll(
					'#subscriber .OT_subscriber video'
				);
				console.log('Main video: ' + mainVideoElement);
			}
		});

		firebase
			.database()
			.ref(
				'ongoing_meetings/' +
					PROJECT_CODE.projectCode +
					'/' +
					infoForFurioos.appointmentId
			)
			.update({
				isVideoEnabled: true,
			});

		session.connect(token, function (error) {
			// If the connection is successful, publish to the session
			notificationAudio.play();
			if (error) {
				handleError(error);
			} else {
				session.publish(publisher, handleError);
			}
		});
		// }, 5000);
	});

	// Connect to the session
	joinWithoutVideo.addEventListener('click', () => {
		previewContainer.style.display = 'none';
		joinMeeting.style.display = 'none';
		joinWithoutVideo.style.display = 'none';
		subscriberContainer.style.display = 'flex';
		sidebar.style.setProperty('display', 'none');
		topbar.style.setProperty('display', 'none');
		layoutContainer.style.backgroundColor = '#000';
		toolbarContainer.style.setProperty('display', 'flex', 'important');
		previewBackground.style.display = 'none';

		publisher.destroy();

		var videoOptionSelect =
			videoSelectorPreview.options[videoSelectorPreview.selectedIndex]?.id;
		var audioOptionSelect =
			audioSelectorPreview.options[audioSelectorPreview.selectedIndex]?.id;
		// var audioOutputOptionSelect =
		// 	audioOutputSelectorPreview.options[
		// 		audioOutputSelectorPreview.selectedIndex
		// 	].id;

		if (audioOptionSelect === 'mute-audio') {
			audioOptionSelect = false;
		} else {
			audioOptionSelect =
				audioSelectorPreview.options[audioSelectorPreview.selectedIndex]?.id;
		}

		var publisherOptions = {
			insertMode: 'append',
			mirror: true,
			style: { buttonDisplayMode: 'off', nameDisplayMode: 'on' },
			width: '100%',
			height: '100%',
			name: displayUser(currentUserDisplayName, currentUserEmail),
			videoSource: videoOptionSelect ? videoOptionSelect : false,
			audioSource: audioOptionSelect,
			showControls: true,
		};

		// Create a publisher
		publisher = OT.initPublisher('subscriber', publisherOptions, (err) => {
			if (err) {
				console.error('Publish error ' + err.message);
			} else {
				displayNotification();
				populateDeviceSourcesModal();
				setupAudioLevelMeterModal();

				var mainVideoElement = document.querySelectorAll(
					'#subscriber .OT_subscriber video'
				);
				console.log('Main video: ' + mainVideoElement);

				// attachSinkId(mainVideoElement, audioOutputOptionSelect);
			}
		});

		publisher.publishVideo(false);

		firebase
			.database()
			.ref(
				'ongoing_meetings/' +
					PROJECT_CODE.projectCode +
					'/' +
					infoForFurioos.appointmentId
			)
			.update({
				isVideoEnabled: false,
			});

		session.connect(token, function (error) {
			// If the connection is successful, publish to the session
			notificationAudio.play();
			if (error) {
				handleError(error);
			} else {
				session.publish(publisher, handleError);
			}
		});
	});

	window.onbeforeunload = function () {
		console.log('popstate');
		publisher.destroy();
		if (isPresenting == true && iPressedPresent == true) {
			firebase
				.database()
				.ref(
					'ongoing_meetings/' +
						PROJECT_CODE.projectCode +
						'/' +
						infoForFurioos.appointmentId
				)
				.update({
					started: false,
				});
		}
		session && session.disconnect(publisher);
		session && session.disconnect(subscriber);
		session && session.disconnect(preview);

		// window.location.reload();
	};

	console.log('pathname: ' + window.location.pathname);

	if (window.location.pathname !== '/videocall') {
		if (isPresenting == true && iPressedPresent == true) {
			firebase
				.database()
				.ref(
					'ongoing_meetings/' +
						PROJECT_CODE.projectCode +
						'/' +
						infoForFurioos.appointmentId
				)
				.update({
					started: false,
				});
		}
		publisher.destroy();
		session && session.disconnect(publisher);
		session && session.disconnect(subscriber);
	}

	furioosAndMatterportImplementation();
	furioosInfo = infoForFurioos;
	function furioosAndMatterportImplementation() {
		isPresenting = false;
		var furioosPresentations = [];
		var matterportPresentations = [];
		var projectMenu = document.querySelector('#project-menu ul');

		//get list of presentations
		firebase
			.database()
			.ref('/kavtek_clients/' + PROJECT_CODE.projectCode)
			.once('value', (snapshot) => {
				var furSnap = snapshot.child('furioos');
				var mattSnap = snapshot.child('matterport');

				//get the list of presentations for furioos
				if (furSnap != null || furSnap !== undefined) {
					furSnap.forEach((element) => {
						var furioosId = element.val().id;
						var furioosName = element.val().name;
						console.log('Link: ' + furioosId);
						furioosPresentations.push(furioosId);

						var li = document.createElement('li');
						li.id = furioosId;
						li.style.cursor = 'pointer';
						li.appendChild(document.createTextNode(furioosName));
						projectMenu.appendChild(li);
					});
				}

				if (mattSnap != null || mattSnap !== undefined) {
					mattSnap.forEach((element) => {
						var mattLink = {
							url: element.val().url,
							name: element.val().name,
						};

						console.log('Matterport links: ' + mattLink);

						matterportPresentations.push(mattLink);

						var mattName = mattLink.name;
						var mattId = mattName.replace(/\s/g, '');

						var li = document.createElement('li');
						li.id = mattLink.url;
						li.style.cursor = 'pointer';
						li.appendChild(document.createTextNode(mattLink.name));
						projectMenu.appendChild(li);
					});
				}
			});

		projectMenu.addEventListener('click', function (e) {
			isPresenting = true;
			iPressedPresent = true;
			var furioosContainer = document.getElementById('furioosContainer');
			var mattaportIframe = document.getElementById('mattaPortIframe');
			furioosContainer.classList.add('OT_big');
			mattaportIframe.classList.add('OT_big');

			console.log('Project btn is clicked - isPresenting = ' + isPresenting);
			var projectBtn = document.getElementById('projectBtn');

			if (callWhenStartingPresentation) {
				callWhenStartingPresentation();
			}

			if (e.target.tagName === 'LI') {
				callback(e.target.id);
				var projectId = e.target.id;

				console.log('Length: ' + projectId.length);

				//matterport
				if (projectId.length > 7) {
					matterportStartedLoading = true;
					furioosContainer.classList.add('hideElement');
					mattaportIframe.classList.remove('hideElement');
					layout();
					console.log('I am from matterport');

					projectBtn.style.color = 'red';
					if (isPresenting == true) {
						mattaportIframe.src = e.target.id;
						console.log('Matterport logic');

						firebase
							.database()
							.ref(
								'ongoing_meetings/' +
									PROJECT_CODE.projectCode +
									'/' +
									infoForFurioos.appointmentId
							)
							.update({
								started: true,
								whatToPresent: projectId,
							});

						
						mattaportIframe.removeEventListener('load', matterpotListener(infoForFurioos), true);
						mattaportIframe.addEventListener(
							'load',
							matterpotListener(infoForFurioos),
							true
						);
					}
				} else if (projectId.length <= 7) {
					//furioos
					console.log('I am from furioos');

					projectBtn.style.color = 'red';

					furioosContainer.classList.remove('hideElement');
					mattaportIframe.classList.add('hideElement');

					layout();
					if (furioosInfo.user_time === undefined) {
						var currentDate = new Date();
						var currentUnix = currentDate.getTime();

						furioosInfo.user_time = currentUnix;
					}

					if (isPresenting == true) {
						console.log('Presenting: ' + isPresenting);

						firebase
							.database()
							.ref(
								'ongoing_meetings/' +
									PROJECT_CODE.projectCode +
									'/' +
									infoForFurioos.appointmentId
							)
							.update({
								started: true,
								whatToPresent: projectId,
							});
					}
				}
			}
		});
	}

	//receiving raise hand signals
	session.on('signal', function (event) {
		toast(event.data);
	});
}

function matterpotListener(infoForFurioos){
	console.log('Showcase loaded');

	var iframe = document.getElementById('mattaPortIframe');
	var sdkKey = '5d092725f51b44618096e7a06edcd99a';

	window.MP_SDK.connect(iframe, sdkKey, '3.0')
		.then(function (sdk) {
			console.log('SDK Connected!');

			// Your Matterport SDK application starts here.
			sdk.Model.getData().then(function (modelData) {
				console.log('Model data loaded for sid:', modelData.sid);
			});

			sdk.Camera.getPose().then(function (pose) {
				console.log('Model data loaded for sid:', pose.position);
			});

			console.log("STARTING NEW MATTERPORT PRESENTATION")

			matterPortSdk = sdk;

			if (iPressedPresent) {
				subscribeToPose(infoForFurioos);
			}

			isMatterportLoaded = true;
			console.log('Matterport is loaded');
		})
		.catch(function (error) {
			console.error(error);
		});
}

export function subscribeToPose(furioosInfo) {
	// var tempAppCode = furioosInfo.appointmentId;
	//probably shouldnmt name this furioos info should name it matterport info?
	var tempAppCode = furioosInfo.appointmentId;

	console.log('This is the tempAppCode: ' + tempAppCode);

	//how do we cancel this if not matterport
	if (isPresenting && iPressedPresent) {
		setTimeout(() => {
			console.log('TIMEOUT START CALL isPresenting' + isPresenting + " iPressedPresent " + iPressedPresent);
			if (isPresenting && iPressedPresent) {
				matterPortSdk.Camera.getPose().then(function (pose) {
					console.log(' THIS Model POSE loaded for sid:', pose.position.x);
					var hostPoseX = pose.position.x;
					var hostPoseY = pose.position.y;
					var hostPoseZ = pose.position.z;
					var hostSweep = pose.sweep;
					console.log(' THIS Model ROT loaded for sid:', pose.rotation.y);
					var hostRotX = pose.rotation.x;
					var hostRotY = pose.rotation.y;
					//hostRotZ = pose.rotation.z;
					console.log('HOST SWEEP ' + hostSweep);

					var poseRef = firebase
						.database()
						.ref(
							'/ongoing_meetings/' +
								PROJECT_CODE.projectCode +
								'/' +
								tempAppCode +
								'/host'
						)
						.child('pose');
					var rotRef = firebase
						.database()
						.ref(
							'/ongoing_meetings/' +
								PROJECT_CODE.projectCode +
								'/' +
								tempAppCode +
								'/host'
						)
						.child('rot');
					var posePush;
					if (hostSweep === undefined) {
						posePush = {
							x: hostPoseX,
							y: hostPoseY,
							z: hostPoseZ,
						};
					} else {
						posePush = {
							sweep: hostSweep,
							x: hostPoseX,
							y: hostPoseY,
							z: hostPoseZ,
						};
					}

					var rotPushRot = {
						x: hostRotX,
						y: hostRotY,
					};

					poseRef.update(posePush);
					rotRef.set(rotPushRot);
				});
				subscribeToPose(furioosInfo);
			} else {
				console.log('presentation status changed unsub from pose');
			}
		}, 500);
	}
}

export function raiseHand() {
	session.signal(
		{
			data:
				displayUser(currentUserDisplayName, currentUserEmail) +
				' raised their hand.',
		},
		function (error) {
			if (error) {
				console.log('Signal Error: ' + error.message);
			} else {
				console.log('Signal Sent');
			}
		}
	);
}

export function callFurioos(projectId, furioosInfo) {
	var furioosContainer = document.getElementById('furioosContainer');
	var mattaportIframe = document.getElementById('mattaPortIframe');

	var layoutContainer = document.getElementById('subscriber');
	var layout = initLayoutContainer(layoutContainer, {
		maxWidth: Infinity,
		maxRatio: 2 / 3,
	}).layout;
	furioosContainer.classList.add('OT_big');
	furioosContainer.classList.remove('hideElement');
	mattaportIframe.classList.add('hideElement');
	layout();
	// start the iframe for furioos
	var furioosCaller = new CallFurioos();
	furioosCaller.startFurioos(
		furioosInfo.user_email,
		furioosInfo.user_name,
		furioosInfo.user_phone,
		furioosInfo.user_avatar,
		furioosInfo.user_time,
		furioosInfo.img_file,
		furioosInfo.user_type,
		furioosInfo.appointmentId,
		furioosInfo.user_id,
		furioosInfo.callBack,
		furioosInfo.iFrameName,
		projectId
	);

	console.log('this is where furioos is called');

	setTimeout(() => {
		console.log(' timneout');
		var layoutContainer = document?.getElementById('subscriber');
		var layout = initLayoutContainer(layoutContainer, {
			maxWidth: Infinity,
			maxRatio: 2 / 3,
		}).layout;
		layout();
	}, 20000);
}

export function callMatterPort(projectId) {
	var furioosContainer = document.getElementById('furioosContainer');
	var mattaportIframe = document.getElementById('mattaPortIframe');
	mattaportIframe.classList.remove('hideElement');
	furioosContainer.classList.add('hideElement');
	mattaportIframe.src = projectId;
	var layoutContainer = document.getElementById('subscriber');
	var layout = initLayoutContainer(layoutContainer, {
		maxWidth: Infinity,
	}).layout;

	matterportStartedLoading = true;

	mattaportIframe.classList.add('OT_big');
	layout();

	mattaportIframe.removeEventListener('load', matterportLoadClient(), true);
	mattaportIframe.addEventListener(
		'load',
		matterportLoadClient(),
		true
	);
}

function matterportLoadClient(){
	console.log('Showcase loaded');

	var iframe = document.getElementById('mattaPortIframe');
	var sdkKey = '5d092725f51b44618096e7a06edcd99a';

	window.MP_SDK.connect(iframe, sdkKey, '3.0')
		.then(function (sdk) {
			console.log('SDK Connected!');

			// Your Matterport SDK application starts here.
			sdk.Model.getData().then(function (modelData) {
				console.log('Model data loaded for sid:', modelData.sid);
			});

			sdk.Camera.getPose().then(function (pose) {
				console.log('Model data loaded for sid:', pose.position);
			});

			matterPortSdk = sdk;

			isMatterportLoaded = true;
			console.log('Matterport is loaded');
		})
		.catch(function (error) {
			console.error(error);
		});
}

export function stopStreaming(meetingID) {
	console.log('hangup clicked - isPresenting = ' + isPresenting);

	if (isPresenting == true && iPressedPresent == true) {
		firebase
			.database()
			.ref('ongoing_meetings/' + PROJECT_CODE.projectCode + '/' + meetingID)
			.update({
				started: false,
			});
	}
	isPresenting = false;

	session.streams.destroy();
	console.log('This is the publiser in stopstreaming', publisher);
	console.log('This is the session in stopstreaming', session);
	console.log('This is the subscriber in stopstreaming', subscriber);
	session.off();

	session && session.disconnect();

	// window.location.pathname = '/';
	session && session.disconnect(publisher);
	session && session.disconnect(subscriber);
	session && session.disconnect(preview);

	publisher.on('streamDestroyed', function (event) {
		console.log('Stream ' + event.stream.name + ' ended.' + event.reason);
	});

	// var otpublisher = document.getElementsByClassName('OT_publisher')[0];
	// otpublisher.remove()
}

export function handleLeaveVideoCall() {
	publisher?.destroy();
}

// The following functions are used in functionality customization
export function toggleVideo(state) {
	console.log('publish video : ' + state);
	publisher.publishVideo(state);
	// publisher.setStyle(
	// 	'backgroundImageURI',
	// 	'https://firebasestorage.googleapis.com/v0/b/kavtek-townvillerealty.appspot.com/o/misc_images%2FdefaultUser.png?alt=media&token=1b64f451-edbc-48f1-9392-c3359554d204'
	// );
}

export function toggleAudio(state) {
	publisher.publishAudio(state);
}

export function toggleScreenShare(state, callbackFunction) {
	console.log('Screenshare: ' + state);

	var screenPreview = document.getElementById('screen-preview');
	var shareScreenBtn = document.getElementById('screen-share-btn');

	console.log('The state is: ' + state);

	callWhenStartingScreenShare = (value) => {
		console.log('calling toggle screenshare callback');
		callbackFunction(state);
	};

	if (state === true) {
		screenPreview?.classList.remove('hideElement');
		var layoutContainer = document.getElementById('subscriber');
		var layout = initLayoutContainer(layoutContainer, {
			maxWidth: Infinity,
		}).layout;
		screenPreview?.classList.add('OT_big');
		shareScreenBtn.style.color = 'red';
		layout();
		OT.checkScreenSharingCapability(function (res) {
			if (!res.supported || res.extensionRegistered === false) {
				console.error(
					'Sorry, this browser does not support screen share at the moment.'
				);
			} else if (res.extensionInstalled === false) {
				console.error(
					'Please install the screen sharing extension and load your app over https.'
				);
			} else {
				console.log('success');
				screenPreview?.classList.remove('hideElement');
				var layoutContainer = document.getElementById('subscriber');
				var layout = initLayoutContainer(layoutContainer, {
					maxWidth: Infinity,
					maxRatio: 2 / 3,
				}).layout;
				shareScreenBtn.style.color = 'red';
				screenPreview?.classList.add('OT_big');
				layout();

				screenshare = OT.initPublisher('screen-preview', {
					videoSource: 'screen',
					insertMode: 'append',
					fitMode: 'contain',
					width: '100%',
					height: '100%',
				});

				session.publish(screenshare, function (error) {
					if (error) {
						console.error('Could not share the screen: ' + error.message);
					}
				});

				screenshare.on('accessDenied', function (event) {
					screenPreview?.classList.add('hideElement');
					shareScreenBtn.style.color = 'white';

					var screenVideo = document.querySelector('#screen-preview video');
					var layoutContainer = document.getElementById('subscriber');
					var layout = initLayoutContainer(layoutContainer, {
						maxWidth: Infinity,
					}).layout;
					screenPreview?.classList.remove('OT_big');
					layout();
				});

				screenshare.on('mediaStopped', function (event) {
					console.log('DID SCREEN SHARE STOP');
					callbackFunction(false);
					event.preventDefault();

					screenPreview?.classList.add('hideElement');
					shareScreenBtn.style.color = 'white';

					var screenVideo = document.querySelector('#screen-preview video');
					var layoutContainer = document.getElementById('subscriber');
					var layout = initLayoutContainer(layoutContainer, {
						maxWidth: Infinity,
					}).layout;
					screenPreview?.classList.remove('OT_big');
					layout();
					session.unpublish(screenshare, function (error) {
						console.log('Unpublisheed');
						if (error) {
							console.error('Error unpublishing');
						} else {
							console.error('Screenshare unpublished');
						}
					});
				});
			}
		});
		var screenVideo = document.querySelector('#screen-preview video');
		callWhenStartingScreenShare();
	} else if (state === false) {
		screenPreview?.classList.add('hideElement');
		shareScreenBtn.style.color = 'white';

		var screenVideo = document.querySelector('#screen-preview video');
		var layoutContainer = document.getElementById('subscriber');
		var layout = initLayoutContainer(layoutContainer, {
			maxWidth: Infinity,
		}).layout;
		screenPreview?.classList.remove('OT_big');
		layout();
		session.unpublish(screenshare, function (error) {
			console.log('Unpublisheed');
			if (error) {
				console.error('Error unpublishing');
			} else {
				console.error('Screenshare unpublished');
			}
		});
		callWhenStartingScreenShare();
	}
}

export function toggleAudioSubscription(state) {
	subscriber.subscribeToAudio(state);
}

export function toggleVideoSubscription(state) {
	subscriber.subscribeToVideo(state);
}

//function to cycle webcam view
export function switchCamera() {
	publisher.cycleVideo();
}

export function stopPresentation() {
	isMatterportLoaded = false;
	matterportStartedLoading = false;

	console.log('THIS IS RAN');

	if (document.querySelector('#furioosContainer iframe')) {
		var layoutContainer = document.getElementById('subscriber');
		var layout = initLayoutContainer(layoutContainer, {
			maxWidth: Infinity,
		}).layout;
		var furioosContainer = document.getElementById('furioosContainer');
		furioosContainer.classList.add('hideElement');
		layout();
		var iframe = document.querySelector('#furioosContainer iframe');
		iframe.remove();
	}

	if (document.querySelector('#subscriber iframe#mattaPortIframe')) {
		var layoutContainer = document.getElementById('subscriber');
		var layout = initLayoutContainer(layoutContainer, {
			maxWidth: Infinity,
		}).layout;
		var mattaportContainer = document.getElementById('mattaPortIframe');
		mattaportContainer.src = '';
		mattaportContainer.classList.add('hideElement');
		layout();
	}
}

export function togglePresentation(state, meetingID, callbackFunction) {
	console.log('THIS IS togglePresentation ' + state);
	var projectBtn = document.getElementById('projectBtn');
	callWhenStartingPresentation = () => {
		console.log('calling toggle presentation callback');
		callbackFunction();
	};
	if (state == true) {
		isPresenting = false;
		console.log('Stop streaming clicked - isPresenting = ' + isPresenting);
		projectBtn.style.color = 'white';

		firebase
			.database()
			.ref('ongoing_meetings/' + PROJECT_CODE.projectCode + '/' + meetingID)
			.update({
				started: false,
			});

		console.log('Presentaion state: ' + state);

		isMatterportLoaded = false;
		matterportStartedLoading = false;

		var layoutContainer = document.getElementById('subscriber');
		var layout = initLayoutContainer(layoutContainer, {
			maxWidth: Infinity,
		}).layout;

		var mattaportContainer = document.getElementById('mattaPortIframe');
		var furioosContainer = document.getElementById('furioosContainer');
		mattaportContainer.classList.add('hideElement');
		furioosContainer.classList.add('hideElement');

		mattaportContainer.src = '';
		projectBtn.style.color = 'white';

		layout();

		callWhenStartingPresentation();
	} else if (state == false) {
		// var screenShareBtn = document.getElementById('screen-share-btn');
		// screenShareBtn.style.color = 'white';
		// projectBtn.style.color = 'red';
	}
}

export function changeToHostPose(
	hostPoseX,
	hostPoseY,
	hostPoseZ,
	hostRotX,
	hostRotY,
	hostSweep
) {
	console.log('SHOULD BE CHANGING THIS USERS ROTATION');

	//this.matterPortSdk.Camera.setRotation({x: hostRotX, y: hostRotY}, {speed: 40});
	var transition = matterPortSdk.Mode.TransitionType.FLY;
	var mode = matterPortSdk.Mode.Mode.INSIDE;
	var zoom = 1;
	var thisPose = {
		x: hostPoseX,
		y: hostPoseY,
		z: hostPoseZ,
	};
	var thisRot = {
		x: hostRotX,
		y: hostRotY,
	};

	console.log(
		'Last pose sweep ' + lastPoseSweep + ' this pose sweep ' + hostSweep
	);
	if (lastPoseSweep != undefined) {
		if (hostSweep != undefined && lastPoseSweep !== hostSweep) {
			console.log('THIS HOST SWEET ' + hostSweep);
			matterPortSdk.Sweep.moveTo(hostSweep, {
				transition: matterPortSdk.Sweep.Transition.INSTANT,
				rotation: thisRot,
				transitionTime: 0.01,
			})
				.finally(() => {
					inTransition = false;
				})
				.catch((error) => {
					console.log(error);
				});
		} else {
			matterPortSdk.Camera.setRotation(
				{ x: hostRotX, y: hostRotY },
				{ speed: 40 }
			);
		}
	} else {
		if (hostSweep != undefined) {
			console.log('THIS HOST SWEET ' + hostSweep);
			matterPortSdk.Sweep.moveTo(hostSweep, {
				transition: matterPortSdk.Sweep.Transition.INSTANT,
				rotation: thisRot,
				transitionTime: 0.01,
			})
				.finally(() => {
					inTransition = false;
				})
				.catch((error) => {
					console.log(error);
				});
		} else {
			matterPortSdk.Camera.setRotation(
				{ x: hostRotX, y: hostRotY },
				{ speed: 40 }
			);
		}
	}
	lastPoseSweep = hostSweep;
}

export function didIPressPresent() {
	return iPressedPresent;
}

export function didMatterportLoaded() {
	return isMatterportLoaded;
}

export function didMaterportStartedLoading() {
	return matterportStartedLoading;
}

//logic to display user email or their full name
export function displayUser(currentUserDisplayName, currentUserEmail) {
	if (currentUserDisplayName === '' || currentUserDisplayName === null) {
		return currentUserEmail;
	} else {
		return currentUserDisplayName;
	}
}

//settings modal
export function settingsModal() {
	var modalContainer = document.querySelector('#deviceSettingsModal');
	var closeBtn = document.querySelector('#btn-close');
	var modalBackdrop = document.querySelector('#modal-drop');

	modalContainer.classList.add('openModal');
	modalBackdrop.style.display = 'block';

	closeBtn.addEventListener('click', () => {
		modalContainer.classList.remove('openModal');
		modalBackdrop.style.display = 'none';
	});

	modalBackdrop.addEventListener('click', () => {
		modalContainer.classList.remove('openModal');
		modalBackdrop.style.display = 'none';
	});
	console.log('I am the settingsModal()');
}
